import React from 'react'
import PropTypes from 'prop-types'
import * as d3 from 'd3'
import * as _ from 'lodash'
import Spinner from 'react-bootstrap/Spinner'
import ScatterPlot from './ScatterPlot'
import Box from '@material-ui/core/Box'
import MakeShiftDrawer from './MakeShiftDrawer'
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import { DISTRO_VIEW, NETWORK_VIEW, BROADCAST_VIEW, GENRE_VIEW, PLAN_VIEW, CUSTOM_VIEW, OTHER, PLAN_VIEW_PLAN,
  DISTRO_VIEW_STREAMING, DISTRO_VIEW_CABLE, DISTRO_VIEW_BROADCAST, DISTRO_VIEW_MOVIE, DISTRO_VIEW_MOVIES, DISTRO_VIEW_PREMIUM,
  DISTRO_VIEW_SPORTS, NETWORK_VIEW_NETFLIX, NETWORK_VIEW_HULU, NETWORK_VIEW_HBO_MAX, NETWORK_VIEW_AMAZON, NETWORK_VIEW_DISNEY_PLUS,
  NETWORK_VIEW_PEACOCK, NETWORK_VIEW_APPLE_TV_PLUS, BROADCAST_VIEW_ABC, BROADCAST_VIEW_CBS, BROADCAST_VIEW_NBC, BROADCAST_VIEW_FOX,
  BROADCAST_VIEW_CW, BROADCAST_VIEW_Cable
} from '../../constants/commons'

class Data extends React.Component {
  static propTypes = {
    plan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      currentPage: PropTypes.number.isRequired,
      endOfResult: PropTypes.bool.isRequired,
      planFilters: PropTypes.object.isRequired,
      details: PropTypes.object
    }).isRequired,
    selectedTopic: PropTypes.string,
    tab: PropTypes.string,
    onUMapSelected: PropTypes.func,
    onUMapDeselect: PropTypes.func,
    selectedPoints: PropTypes.array,
    annotationCount: PropTypes.number,
    genreDemoSummary: PropTypes.object
  }

  constructor (props){
      super(props)
      this.state = {
          status: 'init',
          model_embeddings: null,
          data: null,
          plan: this.props.plan,
          categories: [],
          top5genres: [],
          customEntities: [],
          selectedPoints: [],
          selectedCategory: 'select',
          selectedColor: '#0000FF',
          backgroundColor: '#0000FF',
          displayColorPicker: false,
          changeColor: false,
          isOpen: true,
          // screenWidth: window.innerWidth,
          colors: ['#6372F2', '#DE5F46', '#5BC89A', '#A06BF2', '#F3A467', '#61D1EF', '#E461EF', '#EFD061', 'pink', 'teal', 'grey', 'AliceBlue', 'AntiqueWhite', 'BlueViolet', 'Brown', 'Chartreuse', 'Chocolate', 'Coral', 'DarkCyan', 'DarkGoldenRod', 'HotPink', 'Indigo', 'MediumVioletRed', 'OrangeRed', 'PaleVioletRed', 'MidnightBlue', 'SaddleBrown', 'MediumVioletRed', 'Crimson', 'Salmon', 'Tomato'
        ] //, '#CCCCFF', '#1C0E9C', '#BBA908'
      }
    }

  scaleEmbeddings (embeddings) {
      let xs = embeddings.map(e => Math.abs(e[0]))
      let ys = embeddings.map(e => Math.abs(e[1]))

      let max_x = _.max(xs)
      let max_y = _.max(ys)
      let max = Math.max(max_x, max_y)
      let scale = d3
        .scaleLinear()
        .domain([-max, max])
        .range([-20, 20])
      let scaled_embeddings = embeddings.map(e => [scale(e[0]), scale(e[1])])
      return scaled_embeddings
    }

  componentDidMount () {
    if (this.props.tab !== PLAN_VIEW) {
      this.plotUMap()
    }
    window.addEventListener('resize', this.updateDimensions)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedPoints !== this.props.selectedPoints) {
      this.setState({ selectedPoints: this.props.selectedPoints})
    }
    if (this.state.changeColor) {
      this.plotUMap()
      this.setState({ changeColor: false })
    }
    if (prevProps.selectedTopic !== this.props.selectedTopic || (prevProps.plan !== this.props.plan && this.props.plan.details)) {
      this.setState({
        status: 'init'
      })
    }
    if (prevProps.plan !== this.props.plan && this.props.plan.details && this.props.plan.details.recommendations.length > 0) {
      this.setState({ plan: this.props.plan.details.recommendations })
      if (prevProps.selectedTopic !== this.props.selectedTopic) {
        this.setState({
          status: 'loading'
        })
      } else {
        this.setState({
          status: 'loading'
        })
      }
      this.plotUMap()
    }
  }

  updateDimensions = () => {
    // this.setState({ screenWidth: window.innerWidth })
    // if (window.innerWidth >= 1024) {
    //   this.updateModuleHeight()
    // }
    this.setState({ screenWidth: window.innerWidth })
    // console.log('window dimension', window.innerWidth)
  }

  plotUMap () {
    d3.csv('/data/projections_with_metadata_final.csv')
    .then(data => {
      var x = [],
      y = [],
      s = [],
      c = [],
      t = [],
      a = [],
      color = [];
      let dataArr = {}
      let status = 'loading'
      let categories = []
      let customEntities = []
      if (this.props.tab === GENRE_VIEW) {
        var genres = data.map(item => ({ name: item['topline_genre'], score: item['topline_genre'] === OTHER ? 0 : parseInt(item['num_alignments'])}))
        var genreArr = _(genres)
        .groupBy('name')
        .map((g, name) => ({name, score: _.sumBy(g, 'score')})).orderBy('score', 'desc')
        .value();
        var top5genres = genreArr.slice(0, 10).map(item => item.name)
      }
      if (this.props.tab === CUSTOM_VIEW) {
        customEntities = data.filter(item => item['Custom'] !== OTHER).map(c => c.Custom)
      }
      for (var i = 0; i < data.length; i++) {
        var row = data[i];
        var alignments = Number(row['num_alignments']);
        y.push(row['y']);
        x.push(row['x']);
        a.push(Number(row['num_alignments']))
        if (alignments)
        if (alignments > 300000 && alignments < 1000000) {
          alignments = 300000
        } else if (alignments <= 50000) {
          alignments = 50000
        }
        else if (alignments > 1000000) {
          alignments = 1000000
        }
        s.push(alignments);
        if (this.props.tab === DISTRO_VIEW) { //Distro: Streaming, cable, broadcast, premium, movies, sports and other (podcasts)
          var cat = ''
          if (row['network_categories'] === DISTRO_VIEW_STREAMING) {
            cat = DISTRO_VIEW_STREAMING
            color.push(this.state.colors[0])
          } else if (row['network_categories'] === DISTRO_VIEW_CABLE) {
            cat = DISTRO_VIEW_CABLE
            color.push(this.state.colors[1])
          } else if (row['network_categories'] === DISTRO_VIEW_BROADCAST) {
            cat = DISTRO_VIEW_BROADCAST
            color.push(this.state.colors[2])
          } else if (row['network_categories'] === DISTRO_VIEW_PREMIUM) {
            cat = DISTRO_VIEW_PREMIUM
            color.push(this.state.colors[3])
          } else if (row['topicSubType'] === DISTRO_VIEW_MOVIE) {
            cat = DISTRO_VIEW_MOVIES
            color.push(this.state.colors[4])
          } else if (row['topline_genre'] === DISTRO_VIEW_SPORTS) {
            cat = DISTRO_VIEW_SPORTS
            color.push(this.state.colors[5])
          } else {
            cat = OTHER
            color.push(this.state.colors[10])
          }
          c.push(cat);
        }
        else if (this.props.tab === NETWORK_VIEW) { //Network: Netflix, Hulu, HBO Max and Amazon and other
          cat = ''
          switch (row['networks']) {
            case NETWORK_VIEW_NETFLIX:
              cat = NETWORK_VIEW_NETFLIX
              color.push(this.state.colors[0])
              break
            case NETWORK_VIEW_HULU:
              cat = NETWORK_VIEW_HULU
              color.push(this.state.colors[1])
              break
            case NETWORK_VIEW_HBO_MAX:
              cat = NETWORK_VIEW_HBO_MAX
              color.push(this.state.colors[2])
              break
            case NETWORK_VIEW_AMAZON:
              cat = NETWORK_VIEW_AMAZON
              color.push(this.state.colors[3])
              break
            case NETWORK_VIEW_DISNEY_PLUS:
              cat = NETWORK_VIEW_DISNEY_PLUS
              color.push(this.state.colors[4])
              break
            case NETWORK_VIEW_PEACOCK:
              cat = NETWORK_VIEW_PEACOCK
              color.push(this.state.colors[5])
              break
            case NETWORK_VIEW_APPLE_TV_PLUS:
              cat = NETWORK_VIEW_APPLE_TV_PLUS
              color.push(this.state.colors[6])
              break
            default:
              cat = OTHER
              color.push(this.state.colors[10])
              break
          }
          c.push(cat);
        }
        else if (this.props.tab === BROADCAST_VIEW) { //Broadcast: ABC/CBS/NBC/FOX/CW/Cable/Streaming/Premium/Other
          cat = ''
          switch (row['networks']) {
            case BROADCAST_VIEW_ABC:
              cat = BROADCAST_VIEW_ABC
              color.push(this.state.colors[0])
              break
            case BROADCAST_VIEW_CBS:
              cat = BROADCAST_VIEW_CBS
              color.push(this.state.colors[1])
              break
            case BROADCAST_VIEW_NBC:
              cat = BROADCAST_VIEW_NBC
              color.push(this.state.colors[2])
              break
            case BROADCAST_VIEW_FOX:
              cat = BROADCAST_VIEW_FOX
              color.push(this.state.colors[3])
              break
            case BROADCAST_VIEW_CW:
              cat = BROADCAST_VIEW_CW
              color.push(this.state.colors[4])
              break
            default:
              switch (row['network_categories']) {
                case BROADCAST_VIEW_Cable:
                  cat = BROADCAST_VIEW_Cable
                  color.push(this.state.colors[5])
                  break
                case DISTRO_VIEW_STREAMING:
                  cat = DISTRO_VIEW_STREAMING
                  color.push(this.state.colors[6])
                  break
                case DISTRO_VIEW_PREMIUM:
                  cat = DISTRO_VIEW_PREMIUM
                  color.push(this.state.colors[7])
                  break
                default:
                  cat = OTHER
                  color.push(this.state.colors[10])
                  break
              }
          }
          c.push(cat);
        }
        else if (this.props.tab === GENRE_VIEW) {
          cat = ''
          if (top5genres.indexOf(row['topline_genre']) > -1 ) {
            cat = row['topline_genre']
            color.push(this.state.colors[top5genres.indexOf(row['topline_genre'])])
          } else {
            cat = OTHER
            color.push(this.state.colors[10])
          }
          c.push(cat);
        }
        else if (this.props.tab === PLAN_VIEW) {
          cat = ''
          var plan = this.state.plan.filter(p => p.topic_name === row['topicId'])
          if (plan && plan.length > 0) {
            if (row['id'] === this.props.selectedTopic) {
              cat = row['topicId']
              color.push(this.state.colors[0])
            } else {
              cat = PLAN_VIEW_PLAN
              color.push(this.state.colors[1])
            }
          } else {
            if (row['id'] === this.props.selectedTopic) {
              cat = row['topicId']
              color.push(this.state.colors[0])
            } else {
              cat = OTHER
              color.push(this.state.colors[10])
            }
          }
          c.push(cat);
        }
        else if (this.props.tab === CUSTOM_VIEW) {
          cat = ''
          if (customEntities.indexOf(row['Custom']) > -1 ) {
            cat = row['Custom']
            color.push(this.state.colors[customEntities.indexOf(row['Custom'])])
          } else {
            cat = OTHER
            color.push(this.state.colors[10])
          }
          c.push(cat);
        } else {
          c.push(OTHER);
        }
        t.push(row['topicId']);
        dataArr = {
          type: 'scattergl',
          mode: 'markers',
          x: x,
          y: y,
          text: t,
          marker: { size: s, sizeref: 4000, sizemode: 'area', color: color},
          customdata: a,
          transforms: [{ type: 'groupby', groups: c }],
          hovertemplate:
            '<b>%{text}</b><br><br>' +
            'Engagements: %{customdata}' +
            '<extra></extra>'
        }
        status = this.props.tab !== PLAN_VIEW || (this.props.tab === PLAN_VIEW && this.props.plan.endOfResult) ? 'success' : 'loading'
        categories = c
      }
      this.setState({
        data: [dataArr],
        status: status,
        categories: [...new Set(categories)],
        top5genres: top5genres,
        customEntities: customEntities
      })
    }).catch(() => this.setState({
      status: 'error'
    }))
  }

  onUMapSelected = (data) => {
    this.props.onUMapSelected(data)
  }

  onUMapDeselect = (data) => {
    this.props.onUMapDeselect(data)
  }

  onCategoryChange = (event) => {
    event.persist()
    this.setState({ selectedCategory: event.target.value })
  }

  getIndex = (selectedCategory) => {
    switch (selectedCategory) {
      case DISTRO_VIEW_STREAMING:
        return this.props.tab === DISTRO_VIEW ? 0 : 6
      case NETWORK_VIEW_NETFLIX:
      case BROADCAST_VIEW_ABC:
        return 0
      case DISTRO_VIEW_CABLE:
        return this.props.tab === DISTRO_VIEW ? 1 : 5
      case NETWORK_VIEW_HULU:
      case BROADCAST_VIEW_CBS:
      case PLAN_VIEW_PLAN:
        return 1
      case DISTRO_VIEW_BROADCAST:
      case NETWORK_VIEW_HBO_MAX:
      case BROADCAST_VIEW_NBC:
        return 2
      case DISTRO_VIEW_PREMIUM:
        return this.props.tab === DISTRO_VIEW ? 3 : 7
      case NETWORK_VIEW_AMAZON:
      case BROADCAST_VIEW_FOX:
        return 3
      case DISTRO_VIEW_MOVIES:
      case NETWORK_VIEW_DISNEY_PLUS:
      case BROADCAST_VIEW_CW:
        return 4
      case DISTRO_VIEW_SPORTS:
        return this.props.tab === DISTRO_VIEW ? 5 : this.state.top5genres.indexOf(selectedCategory)
      case NETWORK_VIEW_PEACOCK:
        return 5
      case NETWORK_VIEW_APPLE_TV_PLUS:
        return 6
      default:
        if (this.props.tab === PLAN_VIEW && selectedCategory !== OTHER) {
          return 0
        } else if (this.props.tab === GENRE_VIEW) {
          return this.state.top5genres.indexOf(selectedCategory)
        } else if (this.props.tab === CUSTOM_VIEW) {
          return this.state.customEntities.indexOf(selectedCategory)
        }
        return 10
    }
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  }

  handleChange = (color) => {
    this.setState({ selectedColor: color.hex })
    const index = this.getIndex(this.state.selectedCategory)
    let colors = this.state.colors
    colors[index] = this.state.selectedColor
    this.setState({ colors: colors, changeColor: true})
  }

  handleChangeBackground = (color) => {
    this.setState({ backgroundColor: color.hex })
  }
  toggleDrawer = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  addHighlight = (id) => {
    let entities = this.state.selectedPoints
      entities.map(e => {
        if (e.id === id){
          e.showTooltip = !e.showTooltip
        }
      })
      let annotationCount = entities.filter(e => e.showTooltip)
      this.setState({ selectedPoints: entities})
      this.setState({ annotationCount: annotationCount.length})
  }

  render () {
    const {isOpen} = this.state

    return (
      <div>
        {this.state.status === 'error' && <h3>Error while infering sample</h3>}
        {(this.state.status === 'loading' && (this.props.tab !== PLAN_VIEW || (this.props.tab === PLAN_VIEW && !this.props.plan.endOfResult))) &&
          <Spinner className='umapSpinner' animation="border" />
        }
        {(this.state.status === 'success' && (this.props.tab !== PLAN_VIEW || (this.props.tab === PLAN_VIEW && this.props.plan.endOfResult))) &&
          <>
            <Box style={{width: isOpen ? '75%' : '100%'}} id='discoverLeft'>
              <ScatterPlot
                data={this.state.data}
                onUMapSelected={this.onUMapSelected}
                onUMapDeselect={this.onUMapDeselect}
                selectedPoints={this.state.selectedPoints}
                selectedColor={this.state.selectedColor}
                annotationCount={this.state.annotationCount}
                isOpen={isOpen}
              />
            </Box>
            <Box>
              <Box className={'viewDrawer d-flex align-items-center ' + (isOpen ? 'drawerXS' : 'drawerBlank')} style={{width: isOpen ? '25%' : '0%'}} id='discoverRight'>
                <Box className="drawerAction d-flex align-items-center justify-content-center" onClick={this.toggleDrawer}>
                  {isOpen ? <ArrowRightIcon /> : <ArrowLeftIcon />}
                </Box>
                <MakeShiftDrawer
                  isOpen={isOpen}
                  selectedPoints={this.state.selectedPoints}
                  addHighlight={this.addHighlight}
                  genreDemoSummary={this.props.genreDemoSummary}
                />
              </Box>
            </Box>
          </>
        }
      </div>
      )
  }
}

export default Data